// extracted by mini-css-extract-plugin
module.exports = {"progress-bar":"ProgressBar_progress-bar__l0wRI","track":"ProgressBar_track__I9WTM","indicator":"ProgressBar_indicator__CsGxs","text":"ProgressBar_text__YS_rJ"};